import { Storage } from "@faire/web--source/common/Storage";

export const nextValue = <T>(arr: T[], key: string): T | undefined => {
  const numTimesSeenBanners: number = parseInt(
    Storage.local.getItem(key) ?? "0"
  );
  Storage.local.setItem(key, (numTimesSeenBanners + 1).toString());
  const bannerToShowIndex = numTimesSeenBanners % arr.length;

  return arr[bannerToShowIndex];
};
